import { render, staticRenderFns } from "./qZJFdetail.vue?vue&type=template&id=67cf7315&scoped=true"
import script from "./qZJFdetail.vue?vue&type=script&lang=js"
export * from "./qZJFdetail.vue?vue&type=script&lang=js"
import style0 from "./qZJFdetail.vue?vue&type=style&index=0&id=67cf7315&prod&lang=css"
import style1 from "./qZJFdetail.vue?vue&type=style&index=1&id=67cf7315&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cf7315",
  null
  
)

export default component.exports